export default {
  title: '{{company}} päivitti noutoaikasi',
  new_time_label: 'Uusi aika',
};
